"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptions;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _session = _interopRequireDefault(require("@flowio/session"));

var _getFilteredPayload = _interopRequireDefault(require("./get-filtered-payload"));

var _getErrorCode = _interopRequireDefault(require("./get-error-code"));

var _excluded = ["logLevel", "message"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Returns extra options to be provided to Rollbar. These are standard fields that should be
 * returned for all messages sent to Rollbar no matter what log level is being used. Consistency in
 * this information will help with querying and determining trends over time.
 *
 * @param {Object} action - a redux action
 * @param {Object} store - a store (with getState function) from redux.
 */
// eslint-disable-next-line default-param-last
function getOptions() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = arguments.length > 1 ? arguments[1] : undefined;
  var extendOptionsFn = arguments.length > 2 ? arguments[2] : undefined;
  var state = store.getState();

  var sessionId = _session.default.getSessionId();

  var country = _session.default.getCountry();

  var payload = (0, _getFilteredPayload.default)(action);
  var errorCode = (0, _getErrorCode.default)(action.payload);

  var _get = (0, _get2.default)(action, 'rollbar', {}),
      logLevel = _get.logLevel,
      message = _get.message,
      actionData = (0, _objectWithoutProperties2.default)(_get, _excluded);

  var options = _objectSpread(_objectSpread({}, actionData), {}, {
    sessionId: sessionId,
    country: country,
    action: {
      type: action.type,
      payload: payload
    },
    error: {
      code: errorCode
    }
  });

  if ((0, _isFunction.default)(extendOptionsFn)) {
    return extendOptionsFn({
      state: state,
      options: options
    });
  }

  return options;
}